import script from "./ModalContact.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalContact.vue?vue&type=script&setup=true&lang=js"

import "./ModalContact.vue?vue&type=style&index=0&id=2015e917&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2015e917"]])

export default __exports__